import styled from 'styled-components'

export const Wrapper = styled.div`
    & > * {
        padding-left: 20px;
        padding-right: 20px;
    }
`

export const InnerWrapper = styled.div`
    & > * {
        padding-left: 28px;
        padding-right: 28px;
        @media only screen and (max-width: 500px) {
            padding-left: 0;
            padding-right: 0;
        }
    }
`
